const Support = () => {
  return <div className='container'>support</div>
}

export default Support
